/**
 * @generated SignedSource<<3db6791c8b9f45a2c30f460ad6348d79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type selectProductField_QueryFragment$data = {
  readonly Admin: {
    readonly Billing: {
      readonly SearchProducts: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null;
        };
        readonly " $fragmentSpreads": FragmentRefs<"productsTable_ProductsConnectionFragment">;
      };
    };
  };
  readonly " $fragmentType": "selectProductField_QueryFragment";
};
export type selectProductField_QueryFragment$key = {
  readonly " $data"?: selectProductField_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"selectProductField_QueryFragment">;
};

import SelectProductField_Refetch_graphql from './SelectProductField_Refetch.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "Billing",
  "SearchProducts"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": [
        "License"
      ],
      "kind": "LocalArgument",
      "name": "inKinds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isHiddenOpt"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "titleOpt"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": SelectProductField_Refetch_graphql
    }
  },
  "name": "selectProductField_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAdminSchema",
          "kind": "LinkedField",
          "name": "Billing",
          "plural": false,
          "selections": [
            {
              "alias": "SearchProducts",
              "args": [
                {
                  "kind": "Variable",
                  "name": "inKinds",
                  "variableName": "inKinds"
                },
                {
                  "kind": "Variable",
                  "name": "isHiddenOpt",
                  "variableName": "isHiddenOpt"
                },
                {
                  "kind": "Variable",
                  "name": "titleOpt",
                  "variableName": "titleOpt"
                }
              ],
              "concreteType": "ProductsConnection",
              "kind": "LinkedField",
              "name": "__SelectProductField_SearchProducts_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Product",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "productsTable_ProductsConnectionFragment"
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "76b5801386ec766250d3d2549cf7d46d";

export default node;
